<template>
    <modal :open="open">
        <div v-if="success" class="px-6 py-3 text-base text-green-700 rounded bg-white inset-green-line-left-green-400-md-shadow flex flex-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
            <p class="pl-4">You have successfully subscribed to the interruptions! We have send you an email with an link to confirm the subscription.</p>
        </div>
        <div v-else class="sm:flex sm:items-start">
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-6 w-6 text-green-600">
                    <line x1="22" y1="2" x2="11" y2="13"/>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                </svg>
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Subscribe
                </h3>

                <div class="mt-2">
                    <p class="text-sm leading-5 text-gray-500" v-if="!location && !host && !interruption && !lookup">
                        By entering your email address, you subscribe to <strong>all</strong> future interruptions. Navigate to a location or a host to subscribe a specific scope and do not get emails for all interruptions.
                    </p>
                    <p class="text-sm leading-5 text-gray-500" v-else>
                        By entering your email address, you can subscribe to future interruptions for a specific scope.
                    </p>
                    <div class="mb-6 mt-2">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="email">
                            Email Address
                        </label>
                        <input ref="email" class="shadow appearance-none border border-gray-500 rounded w-full py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none focus:shadow-outline" id="email" type="email" placeholder="tedmosby@zap-hosting.com">
                        <div ref="emailError" v-if="emailErrors.length">
                            <p class="text-red-500 text-xs italic" v-for="item in emailErrors">{{ item }}</p>
                        </div>
                    </div>
                    <div class="mb-6 mt-2" v-if="location || host || interruption || zapService || lookup">
                        <label class="block text-gray-700 text-sm font-bold mb-2" for="scope">
                            Scope
                        </label>
                        <select ref="scope" class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="scope">
                            <option v-if="interruption" :value="'interruptions.interruption.' + interruption" v-html="'Interruption: '+ interruptionName"></option>
                            <option v-if="host" :value="'interruptions.location.' + location + '.host.'+ host" v-html="'Host: '+ hostName"></option>
                            <option v-if="location" :value="'interruptions.location.' + location" v-html="'Location: '+ locationName"></option>
                            <option v-if="zapService" :value="'interruptions.service.' + zapService" v-html="'ZAP Service: '+ zapServiceName"></option>
                            <option v-if="lookup" :value="'interruptions.lookup.' + lookup" v-html="'Lookup: '+ lookupName"></option>
                            <option value="all">All</option>
                        </select>
                        <div ref="scopeError" v-if="scopeErrors.length">
                            <p class="text-red-500 text-xs italic" v-for="item in scopeErrors">{{ item }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <span v-if="success" class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button type="button" @click="closeDialog" class="ml-2 inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                    Nice 💪
                </button>
            </span>
            <span v-else class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button type="button" @click="closeDialog" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-600 shadow-sm hover:bg-gray-100 focus:outline-none focus:border-gray-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                    Abort
                </button>
                <button ref="submitButton" type="button" @click="submitSubscribeDialog()" class="ml-2 inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none">
                    Subscribe
                </button>
            </span>
        </template>
    </modal>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            success: false,
            emailErrors: Array,
            scopeErrors: Array,
        }
    },
    props: {
        location: {
            required: false,
            type: String
        },
        locationName: {
            required: false,
            type: String
        },
        host: {
            required: false,
            type: String
        },
        hostName: {
            required: false,
            type: String
        },
        interruption: {
            required: false,
            type: String
        },
        interruptionName: {
            required: false,
            type: String
        },
        zapService: {
            required: false,
            type: String
        },
        zapServiceName: {
            required: false,
            type: String
        },
        lookup: {
            required: false,
            type: String
        },
        lookupName: {
            required: false,
            type: String
        },
    },
    methods: {
        closeDialog() {
            this.open = false;
            this.success = false;
            this.emailErrors = [];
            this.scopeErrors = [];

            this.$refs.email.value = "";
            if (this.$refs.scope) {
                this.$refs.scope.value = "";
            }
        },
        openSubscribeDialog() {
            this.open = true;
        },
        submitSubscribeDialog() {
            this.$refs.submitButton.disabled = true;

            const email = this.$refs.email.value;
            const scope = (this.location || this.host || this.interruption || this.zapService || this.lookup) ? this.$refs.scope.value : "all";

            axios.post(route('api.subscribe'), {
                email,
                scope
            }).then(function (response) {
                if (response.data.success === true) {
                    this.success = true;
                }
                else {
                    if (response.data.data.email) {
                        this.emailErrors = response.data.data.email;
                        this.$refs.emailError.classList.add("shake");

                        setTimeout(() => {
                            this.$refs.emailError.classList.remove("shake");
                        }, 500);
                    }

                    if (response.data.data.scope) {
                        this.scopeErrors = response.data.data.scope;
                        this.$refs.scopeError.classList.add("shake");

                        setTimeout(() => {
                            this.$refs.scopeError.classList.remove("shake");
                        }, 500);
                    }
                }
            }.bind(this))
                .catch(function (error) {
                    if (error.response.status === 429) {
                        this.emailErrors = ["You have made to many requests! Try again later."];
                        this.$refs.emailError.classList.add("shake");

                        setTimeout(function () {
                            this.$refs.emailError.classList.remove("shake");
                        }.bind(this), 500);
                    }
            }.bind(this))
                .finally(function () {
                    setTimeout(function () {
                        this.$refs.submitButton.disabled = false;
                    }.bind(this), 1000);
                }.bind(this));
        }
    },
}
</script>
